export const initialState = {
  refreshError: null,
  isLoginLoading: true,
  isRefreshing: false,
  isUserLogged: undefined,
  userToken: '',
};
